import type { InferRequestType, InferResponseType } from 'hono/client';
import { type ApiClient, useMutation } from '../api';

type PostBatchCreateRolloutWindows =
  ApiClient['v1']['workspaces'][':workspaceId']['rollout-windows']['create']['$post'];
export type BatchCreateRolloutWindowsRequest =
  InferRequestType<PostBatchCreateRolloutWindows>['json'];
export type BatchCreateRolloutWindowsResponse = InferResponseType<
  PostBatchCreateRolloutWindows,
  200
>;

type PostBatchDeleteRolloutWindows =
  ApiClient['v1']['workspaces'][':workspaceId']['rollout-windows']['delete']['$post'];
export type BatchDeleteRolloutWindowsRequest =
  InferRequestType<PostBatchDeleteRolloutWindows>['json'];
export type BatchDeleteRolloutWindowsResponse = InferResponseType<
  PostBatchDeleteRolloutWindows,
  200
>;

export function useBatchCreateRolloutWindows(workspaceId: number) {
  return useMutation<BatchCreateRolloutWindowsResponse, BatchCreateRolloutWindowsRequest>(
    `workspaces/${workspaceId}/rollout-windows/create`,
    (client, request) =>
      client.v1.workspaces[':workspaceId']['rollout-windows'].create.$post({
        param: { workspaceId: workspaceId.toString() },
        json: request,
      })
  );
}

export function useBatchDeleteRolloutWindowsByTag(workspaceId: number) {
  return useMutation<BatchDeleteRolloutWindowsResponse, BatchDeleteRolloutWindowsRequest>(
    `workspaces/${workspaceId}/rollout-windows/delete`,
    (client, request) =>
      client.v1.workspaces[':workspaceId']['rollout-windows'].delete.$post({
        param: { workspaceId: workspaceId.toString() },
        json: request,
      })
  );
}
